import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouchWithAlignPhysiotherapy from "./sections/GetInTouchWithAlignPhysiotherapy";
import ContactInformation from "./sections/ContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <GetInTouchWithAlignPhysiotherapy />
      <ContactInformation />
      <Footer />
    </div>;
}